import type { CountryCode } from 'libphonenumber-js';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

export function isStringUndefinedNullOrEmpty(value: string | undefined | null): boolean {
  return value === undefined || value === null || value.trim() === '' || value === '\u200B';
}

export function base64ToDataUrl(base64: string, mineType: string) {
  return `data:${mineType};base64,${base64}`;
}

// I took inspiration from here: https://danmarksadresser.dk/om-adresser/saadan-gengives-en-adresse
export function createFullAddress(address: string | null | undefined, houseNumber: string | null | undefined, address2: string | null | undefined, city: string | null | undefined, zipCode: string | null | undefined) {
  // null, undefined and empty strings are all falsy values we wanna check for
  const _address = address || '';
  const _houseNumber = houseNumber ? ` ${houseNumber}` : '';
  const _address2 = address2 ? `, ${address2}` : '';
  const _zipCode = zipCode ? ` ${zipCode}` : '';
  const _city = city ? ` ${city}` : '';

  return `${_address}${_houseNumber}${_address2},${_city} ${_zipCode}`.replace(/^,|,$/g, '').trim();
}

export function stripHtmlTags(html: string): string {
  const doc = new DOMParser().parseFromString(html, 'text/html');

  return doc.body.textContent || '';
}

export function isPhoneNumber(phoneNumber: string): boolean {
  const { locale } = useEkI18n();
  const [, country] = locale.value.split('-');

  const phoneNumberObject = parsePhoneNumberFromString(phoneNumber, { defaultCountry: country as CountryCode, extract: false });

  return phoneNumberObject ? phoneNumberObject.isValid() : false;
}

export function formatPhoneNumber(phoneNumber: string): string {
  const { locale } = useEkI18n();
  const [, country] = locale.value.split('-');

  const phoneNumberObject = parsePhoneNumberFromString(phoneNumber, { defaultCountry: country as CountryCode, extract: false });

  if (!phoneNumberObject) {
    return phoneNumber;
  }

  // Check if the phone number's country code matches the default country code
  if (phoneNumberObject.country === country as CountryCode) {
    return phoneNumberObject.formatNational(); // Format in national format
  } else {
    return phoneNumberObject.formatInternational(); // Format in international format
  }
}
